import { Requerimento, RequerimentoResponse } from 'src/dto'
import {
  Endereco,
  ModalidadeCurso,
  RespostaPadraoDadosAPI,
  TipoOrdenacao
} from 'src/tipos'

import { gatewayApi } from '../instancias-api'
import {
  AvancarPagamentoRequerimentoPayload,
  BoletoGerado,
  GerarBoletoRequerimentoParams
} from './tipos'

export const CriarRequerimentoEmenta = async (
  modalidade: ModalidadeCurso,
  cursoId: string,
  observacao: string
): Promise<any> => {
  const url = '/Requerimento/solicitar/ementa-disciplinas'
  const data = await gatewayApi.post(url, {
    modalidade: modalidade,
    cursoId: cursoId,
    observacao: observacao
  })

  return data
}

export const CriarRequerimentoCertificadoImpresso = async (
  turmaId: string,
  endereco: Endereco,
  matriculaId: string
): Promise<any> => {
  const url = '/Requerimento/solicitar/certificado-impresso'
  const data = await gatewayApi.post(url, {
    turmaId: turmaId,
    endereco: endereco,
    matriculaId: matriculaId
  })

  return data
}

export const ObterRequerimentos = async (
  tipoRequerimento?: string,
  situacaoRequerimento?: string,
  pagina?: number,
  qtdRegistros?: number,
  chaveOrdenacao?: string,
  tipoOrdenacao?: TipoOrdenacao
): Promise<RequerimentoResponse> => {
  const params = new URLSearchParams()
  if (tipoRequerimento) {
    params.set('TipoRequerimento', tipoRequerimento)
  }
  if (situacaoRequerimento) {
    params.set('SituacaoRequerimento', situacaoRequerimento)
  }

  const query = params.toString()
  const url = query ? `Requerimento?${query}` : 'Requerimento'
  const { data } = await gatewayApi.get<RequerimentoResponse>(url)

  return data
}

export const CancelarRequerimentoAluno = async (
  requerimentoId: string
): Promise<any> => {
  const url = `Requerimento/${requerimentoId}/cancelar`
  const { data } = await gatewayApi.put(url)

  return data
}

export const ObterMatriculaComRequerimentoAluno = async (
  matriculaId: string
): Promise<any> => {
  const url = `Requerimento/matricula/${matriculaId}`
  const data = await gatewayApi.get(url)

  return data
}

export const ObterValorTaxaRequerimento = async (): Promise<any> => {
  const url = 'Requerimento/valor-taxa'
  const data = await gatewayApi.get(url)

  return data
}

export const GerarBoletoRequerimento = async ({
  idMatricula,
  diaVencimento,
  cupomId,
  pix
}: GerarBoletoRequerimentoParams): Promise<BoletoGerado> => {
  const { data: boleto } = await gatewayApi.post<BoletoGerado>(
    `/requerimento/${idMatricula}/boleto/cobrar`,
    {
      diaVencimento,
      cupomId,
      pix
    }
  )

  return boleto
}

export const AvancarPagamentoRequerimento = async ({
  matriculaId,
  cupomId,
  dadosCartao
}: AvancarPagamentoRequerimentoPayload): Promise<void> => {
  await gatewayApi.post(`/requerimento/${matriculaId}/pagamento/avancar`, {
    cupomId,
    dadosCartao
  })
}

export const RequisitarDadosRequerimento = async (
  id: string
): Promise<Requerimento> => {
  const response = await gatewayApi.get(`requerimento/${id}`)

  return response.data
}

export const ReenviarEmailSecretaria = async (
  requerimentoId: string
): Promise<void> => {
  await gatewayApi.post(
    `/Requerimento/${requerimentoId}/email-secretaria/reenviar`
  )
}

export const SolicitarLicencaAluno = async (
  form: FormData
): Promise<boolean> => {
  const resposta = await gatewayApi.post(
    '/Requerimento/solicitar/licenca',
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )

  return Boolean(resposta.status < 300)
}
